import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {RainbowTreasure_1Screen} from "../RainbowTreasure/game_1Screen";
export class RainbowTreasureLink_1Screen extends RainbowTreasure_1Screen {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RainbowTreasureLink");
    }

}